import * as Yup from "yup";
import { Formik, Form } from "formik";
import { useState, useEffect } from "react";

import { useHistory, useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

import _ from "lodash";
import moment from "moment";

import Modal from 'react-modal';

import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";

import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiButton from "components/SuiButton";
import SuiSelect from "components/SuiSelect";
import FormikFormField from "components/FormikFormField";
import FormikFormFieldReadOnly from "components/FormikFormFieldReadOnly";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import { Users } from "api";
import { Auth } from "api";

function NewOrEditUser({mode}) {
  const { t } = useTranslation();
  const { id } = useParams();
  const isEditing = !!id;
  const TITLE = t(isEditing ? "Edit User" : "New User");
  const history = useHistory();
  const [user, setUser] = useState({});
  const [userHistory, setUserHistory] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedStatus, setSelectedStatus] = useState();
  const [selectedUserType, setSelectedUserType] = useState();
  const [selectedAreaCode, setSelectedAreaCode] = useState();
  
  const [imageBase64, setImageBase64] = useState('');
  const [isModalOpen, setModalOpen] = useState(false);
  
  const openModal = (base64) => {
    setImageBase64(base64);
    setModalOpen(true);
  };
  
  const closeModal = () => {
    setModalOpen(false);
  };

  const statusOptions = [
    { value: "active", label: t("Active") },
    { value: "inactive", label: t("Inactive") },
  ];

  const userTypeOptions = [
    { value: "Portal User", label: t("Portal User")},
    { value: "Demo", label: t("Demo")},
    { value: "Live", label: t("Live")},    
  ];  

  const areaCodeOptions = [
    { value: "86", label: t("+86 China")},
    { value: "852", label: t("+852 Hong Kong China")},
    { value: "853", label: t("+853 Macau China")},
    { value: "886", label: t("+886 Taiwan China")},
    { value: "60", label: t("+60 Malaysia")},
    { value: "84", label: t("+84 Vietnam")},
  ];  

  const { name, areaCode, mobile, clientId, priceReminderExpiryDate, status, userType } = {
    name: {
      name: "name",
      label: t("Name"),
      type: "text",
      placeholder: t("Name"),
      errorMsg: t("Name is required"),
    },
    areaCode: {
      name: "areaCode",
      label: t("Area Code"),
      type: "text",
      placeholder: t("Choose an Area Code"),      
      errorMsg: t("Area Code is required"),
    },
    mobile: {
      name: "mobile",
      label: t("Mobile Number"),
      type: "text",
      placeholder: t("Mobile Number"),
      invalidMsg: t("Mobile number is invalid"),
      errorMsg: t("Mobile number is required"),
    },
    clientId: {
      name: "clientId",
      label: t("Client ID"),
      type: "text",
      placeholder: t("Client ID"),      
    },
    priceReminderExpiryDate: {
      name: "priceReminderExpiryDate",
      label: t("Price Reminder Expiry Date"),
      type: "text",
      placeholder: t("Price Reminder Expiry Date"),
      invalidMsg: t("Expiry Date is invalid"),
    },
    status: {
      name: "status",
      label: t("Status"),
      type: "select",
      placeholder: t("Choose a status"),
      errorMsg: t("Status is required"),
    },
    userType: {
      name: "userType",
      label: t("User Type"),
      type: "select",
      placeholder: t("Choose a user type"),
      errorMsg: t("User Type is required"),
    },
  };

  const [initialValues, setInitialValues] = useState({
    [name.name]: "",
    [areaCode.name]: "",    
    [mobile.name]: "",
    [clientId.name]: "",
    [priceReminderExpiryDate.name]: "",
    [status.name]: "",
    [userType.name]: ""
  });

  const currentValidation = Yup.object().shape({
    [name.name]: Yup.string().required(name.errorMsg),
    [areaCode.name]: Yup.string().required(areaCode.errorMsg),    
    [mobile.name]: Yup.string().required(mobile.errorMsg),    
    [clientId.name]: Yup.string(),
    [priceReminderExpiryDate.name]: Yup.string(),
    [status.name]: Yup.string(),
    [userType.name]: Yup.string(),
  });

  useEffect(() => {
    if (!isEditing) return;
    (async () => {
      setIsLoading(true);
      try {
        
        const promises = await Promise.allSettled([Users.get({id,ip: '192.168.1.1'})]);
        const [userData] = promises;
        setUser(userData.value.data);
        setUserHistory(userData.value.data.User.history);
        
      } catch (err) {
        console.error(err);
      }
      setIsLoading(false);
    })();
  }, []);

  useEffect(() => {    
    //console.log(user.User);
    if (!isEditing) return;
    if(user.User)
    {
      setInitialValues({ 
        [name.name]: user.User.name,
        [areaCode.name]: user.User.areaCode,
        [mobile.name]: user.User.mobile || "",
        [clientId.name]: user.User.clientId || "",      
        [priceReminderExpiryDate.name]: user.User.priceReminderExpiryDate || "",
        [status.name]: user.User.status,
        [userType.name]: user.User.userType,
      });      
      setSelectedAreaCode(_.first(areaCodeOptions.filter((o) => o.value === user.User.areaCode)));
      setSelectedStatus(_.first(statusOptions.filter((o) => o.value === user.User.status)));
      setSelectedUserType(_.first(userTypeOptions.filter((o) => o.value === user.User.userType)));
    }
  }, [user]);

  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>
      <DashboardLayout>
        <DashboardNavbar />
        <SuiBox my={1.5}>
          <Grid container spacing={3}>
            <Grid item xs={12} lg={isEditing ? 9 : 12}>
            {(!isEditing || (isEditing && !isLoading)) && (
                <Formik
                initialValues={initialValues}
                validationSchema={currentValidation}
                onSubmit={async (values) => {
                  try {
                    const { name, areaCode, mobile, clientId, priceReminderExpiryDate, userType, status  } = values; // eslint-disable-line
                    const data = {
                      name,
                      areaCode,                      
                      mobile: mobile || undefined,
                      clientId: clientId || undefined,
                      priceReminderExpiryDate: priceReminderExpiryDate || undefined,
                      userType,
                      status: status,
                    };
                    if (isEditing) {
                      await Users.update({ id, ...data });
                    } else {
                      await Users.create(data);
                    }
                    history.goBack();
                  } catch (e) {
                    console.error(e);
                  }
                }}
              >
                {({ values, errors, touched, setFieldValue, submitForm }) => {
                const {
                  name: nameV,
                  areaCode: areaCodeV,                  
                  mobile: mobileV,
                  clientId: clientIdV,
                  priceReminderExpiryDate: priceReminderExpiryDateV,                  
                  status: statusV,
                  userType: userTypeV,
                } = values;
                return (
                  <Form autoComplete="off">
              <Card style={{ overflow: "visible" }}>
                <SuiBox p={3}>
                  <SuiTypography variant="h5">{TITLE}</SuiTypography>
                  {/* <SuiTypography variant="button" fontWeight="regular" color="text">
                    {isEditing ? "Edit" : "Create"} admin user
                  </SuiTypography> */}
                  <Divider />
                    <SuiBox>
                      <Grid container>
                        <Grid item xs={12}>
                          <FormikFormField
                            type={name.type}
                            label={name.label}
                            name={name.name}
                            disabled={mode === "view"}
                            value={nameV}
                            placeholder={name.placeholder}
                            error={errors.name && touched.name}
                            success={nameV.length > 0 && !errors.name}
                          />
                          {mode==="view" &&(
                          <FormikFormFieldReadOnly label={areaCode.label} name={areaCode.name} value={t(areaCodeV)}/>
                          )}
                          {mode!=="view" &&(
                          <FormikFormField
                            label={areaCode.label}
                            name={areaCode.name}
                            value={selectedAreaCode}
                            component={SuiSelect}
                            defaultValue={areaCodeV}
                            options={areaCodeOptions}
                            onChange={(option) => {
                              setSelectedAreaCode(option);
                              setFieldValue(areaCode.name, option.value);
                            }}
                          />
                          )}
                          <FormikFormField
                            type={mobile.type}
                            label={mobile.label}
                            name={mobile.name}
                            disabled={mode === "view"}
                            value={mobileV}
                            placeholder={mobile.placeholder}
                            error={errors.mobile && touched.mobile}
                            success={mobileV.length > 0 && !errors.mobile}
                          />  
                          {
                            isEditing && (  
                          <FormikFormField
                            type={clientId.type}
                            label={clientId.label}
                            name={clientId.name}
                            disabled={mode === "view"}
                            value={clientIdV}
                            placeholder={clientId.placeholder}
                            error={errors.clientId && touched.clientId}
                            success={clientIdV.length > 0 && !errors.clientId}
                          />
                            )}
                          {
                            isEditing && (
                          <FormikFormField
                            type={priceReminderExpiryDate.type}
                            label={priceReminderExpiryDate.label}
                            name={priceReminderExpiryDate.name}
                            disabled={mode === "view"}
                            value={priceReminderExpiryDateV}
                            placeholder={priceReminderExpiryDate.placeholder}
                            error={errors.priceReminderExpiryDate && touched.priceReminderExpiryDate}
                            success={priceReminderExpiryDateV.length > 0 && !errors.priceReminderExpiryDate}
                          /> 
                            )}

                          {mode==="view" && isEditing &&(
                          <FormikFormFieldReadOnly label={status.label} name={status.name} value={t(statusV)}/>
                          )}

                          {
                          mode!=="view" && isEditing && (
                          <FormikFormField
                            label={status.label}
                            name={status.name}
                            value={selectedStatus}
                            component={SuiSelect}
                            defaultValue={statusV}
                            options={statusOptions}
                            onChange={(option) => {
                              setSelectedStatus(option);
                              setFieldValue(status.name, option.value);
                            }}
                          />
                          )}
                          {
                            isEditing && (
                          <FormikFormFieldReadOnly label={userType.label} name={userType.name} value={t(user.User.userType)}/>
                            )}
                        </Grid>                                
                      </Grid>
                    </SuiBox>
                    <Grid item xs={12}>
                    <SuiBox display="flex" justifyContent="flex-end" mt={3}>
                    <SuiButton onClick={history.goBack} style={{ marginRight: 15 }}>
                        {t("Cancel")}
                    </SuiButton>
                    {mode!=="view" && (
                    <SuiButton
                        variant="gradient"
                        color="info"
                        disabled={Object.entries(errors).length}
                        onClick={submitForm}
                    >
                        {t(isEditing ? "Update" : "Create")}
                    </SuiButton>
                    )}
                    
                    </SuiBox>                    
                  </Grid>
                </SuiBox>
              </Card>
              <br/>
              {isEditing && user.User.userType==='Demo' && user.User.demoClientId && user.Demo && user.Demo.state === 10000 && (
              <Card style={{ overflow: "visible" }}>
                <SuiBox p={3}>
                  {/* <SuiTypography variant="h5">Department</SuiTypography> */}
                  <SuiTypography variant="button" fontWeight="regular" color="text">
                  {t("Demo Account Information (Read Only)")}
                  </SuiTypography>
                  <Divider />
                  <SuiBox>
                    <Grid container>
                    <Grid item xs={12}>                                        
                    <FormikFormFieldReadOnly label={t("Status")} name={"acccount_state"} value={user.Demo.data.account_state === 1 ? t("Active") : t("Inactive")} />
                    <FormikFormFieldReadOnly label={t("Email")} name={"account_email"} value={user.Demo.data.account_email} />                    
                    </Grid>
                    </Grid>
                </SuiBox>                  
                </SuiBox>
              </Card>
              )}
              {isEditing && user.User.userType==='Live' && user.User.clientId && user.OA && user.OA.state === 10000 && (
              <Card style={{ overflow: "visible" }}>
                <SuiBox p={3}>
                  {/* <SuiTypography variant="h5">Department</SuiTypography> */}
                  <SuiTypography variant="button" fontWeight="regular" color="text">
                  {t("OA Information (Read Only)")}
                  </SuiTypography>
                  <Divider />
                  <SuiBox>
                    <Grid container>
                    <Grid item xs={12}>                    
                    <FormikFormFieldReadOnly label={t("Real Name")} name={"RealName"} value={user.OA.data.name}/>
                    <FormikFormFieldReadOnly label={t("Gender")} name={"gender"} value={t(user.OA.data.gender === "1" ? "Male" : "Female")}/>
                    <FormikFormFieldReadOnly label={t("Mobile")} name={"mobile"} value={user.OA.data.mobile}/>                    
                    <FormikFormFieldReadOnly label={t("Email")} name={"email"} value={user.OA.data.email}/>                    
                    <FormikFormFieldReadOnly label={t("Grade")} name={"grade"} value={t(user.OA.data.grade === "1" ? "Normal Account" : "Professional Account")}/>
                    <FormikFormFieldReadOnly label={t("ID Number")} name={"id_number"} value={user.OA.data.id_number} />
                    <FormikFormFieldReadOnly label={t("ID Type")} name={"id_type"} value={t(user.OA.data.id_type === "1" ? "China ID" : "Others")}/>
                    <FormikFormFieldReadOnly label={t("Address")} name={"adress"} value={user.OA.data.address} />
                    <FormikFormFieldReadOnly label={t("Agent Number")} name={"agent_number"} value={user.OA.data.agent_number} />
                    <FormikFormFieldReadOnly label={t("Referral Code")} name={"referral_code"} value={user.OA.data.referral_code} />
                    <FormikFormFieldReadOnly label={t("Subscribe State")} name={"subscribe_state"} value={t(user.OA.data.subscribe_state=== "1" ? "Subscribed" : "Not yet subscribe")}/>
                    <FormikFormFieldReadOnly label={t("Club State")} name={"club_state"} value={t(user.OA.data.club_state === "1" ? "Registered" : "Not yet register")} />
                    <FormikFormFieldReadOnly label={t("Club Score")} name={"club_score"} value={user.OA.data.club_score} />
                    <FormikFormFieldReadOnly label={t("Club Level")} name={"club_level"} value={user.OA.data.club_level} />
                    <FormikFormFieldReadOnly label={t("Balance")} name={"balance"} value={user.OA.data.balance} />
                    <FormikFormFieldReadOnly label={t("Equity")} name={"equity"} value={user.OA.data.equity} />
                    <FormikFormFieldReadOnly label={t("Margin")} name={"margin"} value={user.OA.data.margin} />
                    {/* Image */}
                    <SuiBox mb={1.5}>
                      <SuiBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                        <SuiTypography
                          component="label"
                          variant="caption"
                          fontWeight="bold"
                          textTransform="capitalize"
                        >
                          {t("ID Front Image")}
                        </SuiTypography>
                      </SuiBox>
                      <br/>
                      <SuiBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                        <SuiTypography
                          component="label"
                          variant="caption"
                          fontWeight="bold"
                          textTransform="capitalize"
                        >
                          {/* Add a link to open the modal */} 
                          <a href="#" onClick={() => openModal(user.ID_FRONT.data.image_data)}>{t("View Image")}</a>
                        </SuiTypography>
                      </SuiBox>
                    </SuiBox>

                    <SuiBox mb={1.5}>
                      <SuiBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                        <SuiTypography
                          component="label"
                          variant="caption"
                          fontWeight="bold"
                          textTransform="capitalize"
                        >
                          {t("ID Back Image")}
                        </SuiTypography>
                      </SuiBox>
                      <br/>
                      <SuiBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                        <SuiTypography
                          component="label"
                          variant="caption"
                          fontWeight="bold"
                          textTransform="capitalize"
                        >
                          {/* Add a link to open the modal */} 
                          <a href="#" onClick={() => openModal(user.ID_BACK.data.image_data)}>{t("View Image")}</a>
                        </SuiTypography>
                      </SuiBox>
                    </SuiBox>

                    <SuiBox mb={1.5}>
                      <SuiBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                        <SuiTypography
                          component="label"
                          variant="caption"
                          fontWeight="bold"
                          textTransform="capitalize"
                        >
                          {t("ID Hand Held Image")}
                        </SuiTypography>
                      </SuiBox>
                      <br/>
                      <SuiBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                        <SuiTypography
                          component="label"
                          variant="caption"
                          fontWeight="bold"
                          textTransform="capitalize"
                        >
                          {/* Add a link to open the modal */} 
                          <a href="#" onClick={() => openModal(user.HAND_HELD.data.image_data)}>{t("View Image")}</a>
                        </SuiTypography>
                      </SuiBox>
                    </SuiBox>

                    <SuiBox mb={1.5}>
                      <SuiBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                        <SuiTypography
                          component="label"
                          variant="caption"
                          fontWeight="bold"
                          textTransform="capitalize"
                        >
                          {t("Bank Card Image")}
                        </SuiTypography>
                      </SuiBox>
                      <br/>
                      <SuiBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                        <SuiTypography
                          component="label"
                          variant="caption"
                          fontWeight="bold"
                          textTransform="capitalize"
                        >
                          {/* Add a link to open the modal */} 
                          <a href="#" onClick={() => openModal(user.BANK_CARD.data.image_data)}>{t("View Image")}</a>
                        </SuiTypography>
                      </SuiBox>
                    </SuiBox>

                    <Modal isOpen={isModalOpen} onRequestClose={closeModal}                      
                      style={{
                        content: {
                          width: '50%',
                          height: '50%',
                          backgroundColor: 'white',
                          top: '50%',
                          left: '50%',
                          transform: 'translate(-50%, -50%)',
                        },
                        overlay: {
                          position: 'fixed',
                          top: 0,
                          left: 0,
                          right: 0,
                          bottom: 0,
                          backgroundColor: 'rgba(0, 0, 0, 0.5)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        },
                      }}
                    >
                        <button
                          style={{
                            position: 'absolute',
                            top: '10px',
                            right: '10px',
                            padding: '5px',
                            border: 'none',
                            background: 'none',
                            fontSize: '24px',
                            cursor: 'pointer',
                          }}
                          onClick={closeModal}
                        >
                          &times;
                        </button>
                        <img src={`${imageBase64}`} alt="Popup Image" 
                          style={{                            
                            top: '30px'
                          }}
                        />
                    </Modal>

                    {/* <SuiTypography component="label" variant="caption" fontWeight="bold" textTransform="capitalize">
                      ID Front
                    </SuiTypography>
                    <br/>
                    {
                    user.ID_FRONT.data.image_data &&
                    (<img src={user.ID_FRONT.data.image_data} style="max-width: 100px; max-height: 100px;"/>)
                    } */}
                    </Grid>
                    </Grid>
                </SuiBox>
                  
                </SuiBox>
              </Card>
              )}
              <br/>
              {isEditing && user.User.userType==='Live' && user.User.clientId && user.OA && user.OA.state === 10000 && (
              <Card style={{ overflow: "visible" }}>
                <SuiBox p={3}>
                  {/* <SuiTypography variant="h5">Department</SuiTypography> */}
                  <SuiTypography variant="button" fontWeight="regular" color="text">
                  {t("Bank Information (Read Only)")}
                  </SuiTypography>
                  <Divider />
                  <SuiBox>
                    <Grid container>
                    <Grid item xs={12}>                                        
                    <FormikFormFieldReadOnly label={t("Bank Name")} name={"bank_name"} value={user.OA.data.bank_name} />
                    <FormikFormFieldReadOnly label={t("Bank User Name")} name={"bank_username"} value={user.OA.data.bank_username} />
                    <FormikFormFieldReadOnly label={t("Bank Account")} name={"bank_account"} value={user.OA.data.bank_account} />
                    <FormikFormFieldReadOnly label={t("Bank Branch")} name={"bank_branch"} value={user.OA.data.bank_branch} />
                    </Grid>
                    </Grid>
                </SuiBox>
                  
                </SuiBox>
              </Card>
              )}              
              
              </Form>
            );
            }}
              </Formik>
              )}
            </Grid> 
            {isEditing && (
              <Grid item xs={12} lg={3}>
                <TableContainer style={{ padding: 5 }}>
                  <Table>
                    <TableHead>
                      <SuiBox component="tr" width="max-content" display="block" mb={1.5}>
                        <SuiTypography variant="h5" component="td">
                          {t("History")}
                        </SuiTypography>
                      </SuiBox>
                    </TableHead>
                    <TableBody>
                      {isEditing && !isLoading && (
                        <>
                          {userHistory.map((data) => (
                            <TableRow>
                              <TableCell>
                                <SuiTypography variant="button" fontWeight="regular" color="text">
                                  {moment(data.date).format("YYYY-MM-DD HH:mm")}
                                </SuiTypography>
                              </TableCell>
                              <TableCell>
                                <SuiTypography variant="button" color="text">
                                  {/* {`Updated status to ${data.message}`} */}
                                  {`${data.message}`}
                                </SuiTypography>
                              </TableCell>
                            </TableRow>
                          ))}
                        </>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            )}           
          </Grid>
        </SuiBox>
        <Footer />
      </DashboardLayout>
    </>
  );
}

export default NewOrEditUser;
